export default "/fonts/Flaticon2.svg?79370877b4f6af461592daf107da82bb";